import "./CompleteModal.css";
import { ImCancelCircle } from "react-icons/im";
import CustomButton from "../customButton/CustomButton";
import ReactStars from "react-rating-stars-component";
import { useState } from "react";
import { useTypedSelector } from "../../hook/useTypedSelector";
import { useCompleteApplicantJobMutation } from "../../store/query/applicants";
import { toast } from "react-toastify";

const CompletedModal = ({ close, appId, details, manageRefetch }) => {
  const { user } = useTypedSelector((store) => store.appUser);
  const [completeApplicantJob, { isLoading }] =
    useCompleteApplicantJobMutation();
  const [comment, setComment] = useState("");
  const [listItems, setListItems] = useState([
    {
      id: "punctuality",
      title: "Punctuality",
      desc: "⏰ Arrived on time, reliable attendance.",
      count: 0,
    },
    {
      id: "communication",
      title: "Communication",
      desc: "💬 Clear, respectful, and responsive communication.",
      count: 0,
    },
    {
      id: "professional_knowledge",
      title: "Professional Knowledge",
      desc: "📚 Medical skills and knowledge displayed on the job.",
      count: 0,
    },
    {
      id: "teamwork",
      title: "Teamwork & Collaboration",
      desc: "🤝 Cooperated well with the team.",
      count: 0,
    },
    {
      id: "patient_interaction",
      title: "Patient Interaction",
      desc: "❤️ Engaged with patients compassionately.",
      count: 0,
    },
  ]);

  const ratingChanged = (newRating, id) => {
    const updatedItems = listItems.map((item) =>
      item.id === id ? { ...item, count: newRating } : item
    );
    setListItems(updatedItems);
  };

  const handleSubmit = async () => {
    const ratingPayload = listItems.reduce((acc, item) => {
      acc[item.id] = item.count;
      return acc;
    }, {});
    let payload = {
      type: user?.account_type,
      job_id: details.job_id,
      applicant_id: appId,
      applicant_account_type: details.app_type,
      comment: comment,
      ...ratingPayload,
    };

    const res = await completeApplicantJob({
      ...payload,
    });

    //console.log("res", res);

    if (res.data.status) {
      toast.success(
        res.data.message ?? "Applicant Job was completed Successfully"
      );
      close();
      await manageRefetch();
    } else {
      toast.error("Failed to completed applicant job");
    }
  };
  //console.log("completed", details, appId);

  const hasZeroRating = listItems.some((item) => item.count === 0);

  return (
    <div className="complete-modal-container">
      <ImCancelCircle className="icon-can" onClick={close} />
      <div className="complete-modal-content">
        <div className="header">
          <h4>Rate this Healthcare Professional</h4>
        </div>

        <div className="main-content">
          <p className="desc">
            Help us maintain quality of service by rating before completion
          </p>
          <div className="list-rating">
            {listItems.map(({ id, title, desc }) => (
              <div key={id} className="each-list">
                <div>
                  <h6>{title}</h6>
                  <p>{desc}</p>
                </div>

                <div>
                  <ReactStars
                    count={5}
                    onChange={(e) => ratingChanged(e, id)}
                    size={25}
                    activeColor="#ffd700"
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="text-field">
            <label>Additional Comments (optional)</label>
            <textarea
              cols="10"
              rows="3"
              placeholder="Any extra feedback you'd like to share?"
              disabled={isLoading}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            ></textarea>
          </div>

          <div className="warning-acc">
            <p>
              <span>ATTENTION!! </span> <br /> Kindly confirm the job is fully
              completed before marking it as done. Payment will be auto-released
              and cannot be reversed. If there is any complaint, use the
              "Complaint" and we will initiate enquiry.
            </p>
          </div>

          <CustomButton
            customStyles={{
              marginTop: "10px",
              width: "100%",
              height: "40px",
              fontSize: "16px",
              borderRadius: "5px",
            }}
            title="Submit Rating & Mark Job as Completed"
            onClick={handleSubmit}
            disable={isLoading || hasZeroRating}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default CompletedModal;
